module.exports = __webpack_public_path__ + "img/08_white bg LANDSCAPE.7d56d421.png";